<div class="contents-area">
  <wj-tab-panel #tab_Mark id="tab_Mark" (selectedTabChange)="selectedTabChange()">
    <wj-tab>
      <a id="a_Mark" #a_Mark>マーク</a>
      <div>
        <h1>マーク一覧</h1>
        <div class="element-column">
          <div class="layout_balance">
            <button class="btn-secondary" id="btn_SearchMark" #btn_SearchMark (click)="eventSearchMark_CLICKHandler()"
              [tabindex]="0" forcedEnabledMode="'true">検索</button>
            <div class="action-area">
              <app-checkbox-label id="chk_DisplayEndMark" #chk_DisplayEndMark [subid]="'chk_DisplayEndMark'"
                label="使用終了マークを表示" [tabindex]="0" [(ngModel)]="model.displayEndMark"
                (change)="eventDisplayEndMark_CLICKHandler()" style="display:flex; align-items:center;"
                [forcedEnabledMode]="'true'">
              </app-checkbox-label>
              <label>件数：</label>
              <label id="lbl_MarkFileNum">
                {{model.markFileNum}}
              </label>
            </div>
          </div>
          <wj-flex-grid [style.height.px]="695" #dtg_MarkList
            [itemsSource]="model.markFileListForView" id="dtg_MarkList" [isReadOnly]="true"
            [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'"
            [tabindex]="0">
            <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="150" [binding]="'markGroupName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク\nコード'" [width]="80" [binding]="'markCode'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク名'" [width]="400" [binding]="'markName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク画像'" [width]="257" [binding]="'markFileUrl'" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [style.text-align]="'center'">
                  <img src="{{cell.item.markFileUrl}}" class="cell-img">
                </div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク\nファイル名'" [width]="90" [binding]="'markFileName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'使用開始\n配達企画回(翌週)'" [width]="130"
              [binding]="'startDelivCatalogId'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'使用終了\n配達企画回(翌週)'" [width]="130"
              [binding]="'endDelivCatalogId'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク区分'" [width]="140" [binding]="'supplyPromoteMarkDiv'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク\n登録日'" [width]="110" [binding]="'registDate'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マークファイル\n登録日'" [width]="110"
              [binding]="'fileRegistDate'">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </wj-tab>

    <wj-tab>
      <a id="a_CwsIcon" #a_CwsIcon>アイコン</a>
      <div>
        <h1>アイコン一覧</h1>
        <div class="element-column">
          <div class="action-area">
            <app-checkbox-label id="chk_DisplayEndCwsIconData" #chk_DisplayEndCwsIconData
              [subid]="'chk_DisplayEndCwsIconData'" label="使用終了アイコンを表示" [tabindex]="0"
              [(ngModel)]="model.displayEndCwsIconData" (change)="eventDisplayEndCwsIconData_CLICKHandler()"
              style="display:flex; align-items:center;" [forcedEnabledMode]="'true'">
            </app-checkbox-label>
            <label>件数：</label>
            <label id="lbl_CwsIconDataNum">
              {{model.cwsIconDataNum}}
            </label>
          </div>
          <wj-flex-grid [style.height.px]="705" #dtg_CwsIconDataList
            [itemsSource]="model.cwsIconDataListForView" id="dtg_CwsIconDataList" [isReadOnly]="true"
            [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'"
            [selectionMode]="'Row'" [tabindex]="0">
            <wj-flex-grid-filter #flr_CwsIconDataList></wj-flex-grid-filter>
            <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="120" [binding]="'iconGroupName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン\nコード'" [width]="80" [binding]="'iconCode'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'連番'" [width]="50" [binding]="'iconCodeBranch'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン名'" [width]="227" [binding]="'iconName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン\n画像'" [width]="120" [binding]="'iconImageUrl'" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [style.text-align]="'center'">
                  <img src="{{cell.item.iconImageUrl}}" class="cell-img">
                </div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン代替\nテキスト'" [width]="120"
              [binding]="'iconAlternativeText'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'使用開始\n配達企画回(翌週)'" [width]="130"
              [binding]="'delivCatalogIdStart'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'使用終了\n配達企画回(翌週)'" [width]="130"
              [binding]="'delivCatalogIdEnd'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン区分'" [width]="100" [binding]="'iconDiv'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'配置区分'" [width]="70" [binding]="'arrangeDiv'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'アイコン説明'" [width]="240" [binding]="'iconExplain'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'出力区分'" [width]="230" [binding]="'outputDivStr'"
              [cssClass]="'white-space'">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </wj-tab>

    <wj-tab>
      <a id="a_Relation" #a_Relation>関連</a>
      <div class="block-column">
        <div class="column-list">
          <label class="list-input-title">表示切替</label>
          <div class="list-input-content" id="grp_DisplayList">
            <app-radio-label name="grp_DisplayList" label="アイコン" value="1" id="rdb_CwsIconList" #rdb_CwsIconList
              [subid]="'rdb_CwsIconList'" [forcedEnabledMode]="'true'" [tabindex]="0" [checked]="true"
              [(ngModel)]="model.radioBtnValue" (change)="eventDisplayList_CLICKHandler()">
            </app-radio-label>
            <app-radio-label name="grp_DisplayList" label="マーク" value="2" id="rdb_MarkList" #rdb_MarkList
              [subid]="'rdb_MarkList'" [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="model.radioBtnValue"
              (change)="eventDisplayList_CLICKHandler()">
            </app-radio-label>
          </div>
        </div>

        <div class="block-row">
          <div>
            <h1>関連一覧</h1>
            <wj-flex-grid [style.height.px]="677" #dtg_MarkConvInfoList class="convInfoList"
              [itemsSource]="model.markConvInfoListForView" id="dtg_MarkConvInfoList" [isReadOnly]="true"
              [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'"
              [selectionMode]="'Row'" [tabindex]="0">
              <wj-flex-grid-filter #flr_MarkConvInfoList></wj-flex-grid-filter>
              <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="120" [binding]="'iconGroupName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'アイコン\nコード'" [width]="60" [binding]="'iconCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'連番'" [width]="50" [binding]="'iconCodeBranch'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'アイコン名'" [width]="191" [binding]="'iconName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'アイコン画像'" [width]="95" [binding]="'iconImageUrl'" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [style.text-align]="'center'">
                    <img src="{{cell.item.iconImageUrl}}" class="cell-img">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'関連対象マーク'" [width]="120" [binding]="'markFileName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'マーク画像'" [width]="193" [style.height]="'auto'" [align]="'center'"
                [binding]="'markFileUrl'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [style.text-align]="'center'">
                    <img src="{{cell.item.markFileUrl}}" class="cell-img">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
            </wj-flex-grid>

            <wj-flex-grid [style.height.px]="677" #dtg_CwsIconConvInfoList class="convInfoList"
              [itemsSource]="model.cwsIconConvInfoListForView" id="dtg_CwsIconConvInfoList" [isReadOnly]="true"
              [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'"
              [selectionMode]="'Row'" [tabindex]="0" [style.display]="'none'">
              <wj-flex-grid-filter #flr_CwsIconConvInfoList></wj-flex-grid-filter>
              <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="120" [binding]="'markGroupName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'マーク\nコード'" [width]="60" [binding]="'markCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'連番'" [width]="50" [binding]="'markCodeBranch'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'マーク名'" [width]="191" [binding]="'markName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'マーク画像'" [width]="193" [binding]="'markFileUrl'" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [style.text-align]="'center'">
                    <img src="{{cell.item.markFileUrl}}" class="cell-img">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'関連対象\nアイコン'" [width]="120" [binding]="'iconFileName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'アイコン画像'" [width]="95" [binding]="'iconUrl'" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [style.text-align]="'center'">
                    <img src="{{cell.item.iconUrl}}" class="cell-img">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>

          <div class="set-btn-position">
            <button class="btn-secondary" id="btn_Set" #btn_RegistMark (click)="eventSet_CLICKHandler()" [tabindex]="0"
              forcedEnabledMode="">＜＜</button>
          </div>

          <div>
            <h1>{{model.displayListName}}</h1>
            <wj-flex-grid [style.height.px]="677" #dtg_MarkListForRelation class="listForRelation"
              [itemsSource]="model.markFileListForView" id="dtg_MarkListForRelation" [isReadOnly]="true"
              [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'"
              [selectionMode]="'Row'" [tabindex]="0">
              <wj-flex-grid-filter #flr_MarkListForRelation></wj-flex-grid-filter>
              <wj-flex-grid-column [header]="' '" [width]="40" [binding]="'check'" [isReadOnly]="true" [minWidth]="5">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" [tabindex]="-1"
                    (mouseup)="$event.stopPropagation()" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="150" [binding]="'markGroupName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'マーク\nコード'" [width]="80" [binding]="'markCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'連番'" [width]="80" [binding]="'markCodeBranch'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'マーク名'" [width]="159" [binding]="'markName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'マーク画像'" [width]="110" [binding]="'markFileUrl'" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [style.text-align]="'center'">
                    <img src="{{cell.item.markFileUrl}}" class="cell-img">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
            </wj-flex-grid>

            <wj-flex-grid [style.height.px]="677" #dtg_CwsIconDataListForRelation class="listForRelation"
              [itemsSource]="model.cwsIconDataListForView" id="dtg_CwsIconDataListForRelation" [isReadOnly]="true"
              [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'"
              [selectionMode]="'Row'" [tabindex]="0" [style.display]="'none'">
              <wj-flex-grid-filter #flr_CwsIconDataListForRelation></wj-flex-grid-filter>
              <wj-flex-grid-column [header]="' '" [width]="40" [binding]="'check'" [align]="'center'" [minWidth]="5"
                [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" class="selected" [(ngModel)]="cell.item.check"
                    (click)="$event.stopPropagation()" [tabindex]="-1" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'グループ'" [width]="120" [binding]="'iconGroupName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'アイコン\nコード'" [width]="60" [binding]="'iconCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'連番'" [width]="50" [binding]="'iconCodeBranch'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'アイコン名'" [width]="239" [binding]="'iconName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'アイコン\n画像'" [width]="110" [binding]="'iconImageUrl'" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [style.text-align]="'center'">
                    <img src="{{cell.item.iconImageUrl}}" class="cell-img">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
    </wj-tab>
  </wj-tab-panel>
</div>


<ng-container *ngIf="0 == tab_Mark.selectedIndex">
  <footer class="footer-buttons">
    <button class="btn-secondary" id="btn_RegistMark" #btn_RegistMark (click)="eventRegistMark_CLICKHandler()"
      [tabindex]="0" [disabled]="model.registMarkBtnDisabled">マークを登録</button>
    <button class="btn-secondary" id="btn_RegistMarkFile" #btn_RegistMarkFile
      (click)="eventRegistMarkFile_CLICKHandler()" [tabindex]="0"
      [disabled]="model.registMarkFileBtnDisabled">マークファイルを登録</button>
  </footer>
</ng-container>
<ng-container *ngIf="1 == tab_Mark.selectedIndex">
  <footer class="footer-buttons">
    <button class="btn-primary" id="btn_RegistCwsIconData" #btn_RegistCwsIconData
      (click)="eventRegistCwsIconData_CLICKHandler()" [tabindex]="0"
      [disabled]="model.registCwsIconDataBtnDisabled">アイコンを登録</button>
  </footer>
</ng-container>
<ng-container *ngIf="2 == tab_Mark.selectedIndex">
  <footer class="footer-buttons">
    <button class="btn-primary" id="btn_UpdateMarkOrCwsIcon" #btn_RegistCwsIconData
      (click)="eventUpdateMarkOrCwsIcon_CLICKHandler()" [tabindex]="0"
      [disabled]="model.updateMarkOrCwsIconBtnDisabled">更新</button>
  </footer>
</ng-container>